import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const UploadIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <rect
                    style={{
                        fill: "none",
                    }}
                    width="20"
                    height="20"
                />
                <polygon
                    style={{
                        fill: "currentColor",
                    }}
                    points="17.01 17.38 3.07 17.38 3.07 13.51 4.27 13.51 4.27 16.18 15.81 16.18 15.81 13.51 17.01 13.51 17.01 17.38"
                />
                <polygon
                    style={{
                        fill: "currentColor",
                    }}
                    points="4.73 7.87 3.96 6.94 9.95 2.02 15.81 6.94 15.03 7.86 9.94 3.58 4.73 7.87"
                />
                <rect
                    style={{
                        fill: "currentColor",
                    }}
                    x="9.35"
                    y="2.82"
                    width="1.2"
                    height="11.79"
                />
            </g>
        </SvgIcon>
    );
};
